<template>
  <button
    v-on="listeners"
    v-bind="attrs"
    :type="type"
    :class="[custom, sizeClasses, modeClasses, isLoading, { disabled: disabled, 'has-group': group }]"
    class="cbutton"
    :disabled="disabled"
    :aria-label="ariaLabel"
  >
    <span class="flex items-center">
      <base-icon
        class="hidden md:block mr-2"
        :name="icon"
        size="sm"
        v-if="forceIcon"
      />
      <base-icon
        class="block md:hidden"
        :name="icon"
      />
      <span class="hidden md:block">{{ text }}</span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'base-button-responsive',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button'
    },
    mode: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    icon: {
      type: String,
      default: 'none'
    },
    forceIcon: {
      type: Boolean,
      default: false
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    group: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: null,
    }
  },
  computed: {
    listeners: function () {
      return {
        ...this.$listeners
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    isLoading: function () {
      return { 'loader-in-element': this.loading }
    },
    sizeClasses: function () {
      return {
        'w-12 md:w-auto h-12 md:h-8 md:px-4': this.size === 'xs',
        'w-12 md:w-auto h-12 md:h-10 md:px-6': this.size === 'md'
      }
    },
    modeClasses: function () {
      return {
        'cbutton--primary': this.mode === 'primary',
        'cbutton--staticprimary': this.mode === 'staticprimary',
        'cbutton--secondary': this.mode === 'secondary',
        'cbutton--prim-phantom': this.mode === 'primary-phantom',
        'cbutton--staticprim-phantom': this.mode === 'staticprimary-phantom',
        'cbutton--sec-phantom': this.mode === 'secondary-phantom',
        'cbutton--prim-line': this.mode === 'primary-line',
        'cbutton--tools': this.mode === 'tools',
        'cbutton--core': this.mode === 'core',
        'cbutton--sec-phantom-blue': this.mode === 'secondary-phantom-blue',
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/BaseButton.scss";
  .cbutton {
    @apply rounded-full md:rounded;
  }
</style>
